import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import DealsBoard from '@/components/deals/deals-board'
import { pipelineBySlug } from '@/constants/crm'
import { loadCrmPageProps } from '@/lib/crm-page'
import { cn } from '@/lib/utils'

type PipelinePageProps = Partial<CrmPageProps> & {
    slug: string
}

const PipelinePage: FC<PipelinePageProps> = ({ data, today, slug }): ReactNode => {
    const pipeline = pipelineBySlug(slug)

    if (!pipeline) return null

    return (
        <AppShell
            data={data}
            today={today ?? ''}
            title={`${pipeline.label} pipeline`}
            description={`Deals in the ${pipeline.label} pipeline, by stage.`}
        >
            <PageHeader
                title={pipeline.label}
                pill={(
                    <span className='caption-style bg-muted inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#363636] py-[3px] pr-[7px] pl-[6px]'>
                        <span aria-hidden className={cn('size-1.5 rounded-full', pipeline.dot)} />
                        Pipeline
                    </span>
                )}
            />
            <DealsBoard pipeline={pipeline.label} />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<PipelinePageProps> = async ({ params }) => {
    const slug = typeof params?.slug === 'string' ? params.slug : ''

    if (!pipelineBySlug(slug)) return { notFound: true }

    return { props: { ...(await loadCrmPageProps()), slug } }
}

export default PipelinePage
